//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//

import _ from 'lodash';

export default {
  name: 'DpGridRow',
  props: {
    device: { type: [Object, Array], default: () => null },
    columns: { type: Array, default: () => [] },
    settings: { type: Object, default: () => ({}) },
    selections: { type: Array, default: () => [] },
    kpi: { type: Object, default: null },
  },
  computed: {
    isSelected() {
      let selected = false;
      if (Array.isArray(this.selections)) {
        this.selections.forEach((sel) => {
          if (_.isEqual(sel, this.device)) {
            selected = true;
          }
        });
      }
      return selected;
    },
    visibleColumns() {
      return this.columns.filter((c) => c.visible);
    },
  },
  methods: {
    getStyle(c) {
      const styleObj = {};
      if (c.width) {
        styleObj.flex = `0 0 ${c.width}px`;
      }
      return styleObj;
    },
    clickRow(e) {
      this.$emit('click', e);
    },
  },
};
